import { render, staticRenderFns } from "./living_countdown.vue?vue&type=template&id=90598d40&scoped=true&"
import script from "./living_countdown.vue?vue&type=script&lang=js&"
export * from "./living_countdown.vue?vue&type=script&lang=js&"
import style0 from "./living_countdown.vue?vue&type=style&index=0&id=90598d40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90598d40",
  null
  
)

export default component.exports